<div class="dialog-wrap">
  <h3>{{"SUBSCRIPTIONS_DIALOG.HEADING" | translate}}</h3>
  <span (click)="close()" class="material-symbols-outlined close-icon"> close </span>

  <div class="subscriptions-list">
    <h3>{{"SHOP.SUBSCRIPTIONS_LINKS" | translate}}</h3>
    <div class="subscription">
      <button mat-raised-button color="primary"
              (click)="openSubscription('month')">{{"SHOP.MONTHLY_SUBSCRIPTION" | translate}}</button>
    </div>
  </div>
</div>
